// extracted by mini-css-extract-plugin
export default {"VacationCardInfo":"VacancyCardInfo_VacationCardInfo__Mp4tZ"};